module.exports = __webpack_public_path__ + "assets/img/6.e6dd3cda.jpg";